import Notes from "./Notes";

import styles from "./CareComponentNotes.module.scss";

interface CounselingNotesProps {
    id: string;
    dataCy?: string;
    label?: string;
    value?: string;
    isEditable: boolean;
    onTextChange: (value: string) => void;
}

function CareComponentNotes({ id, dataCy, isEditable, label, value = "", onTextChange }: Readonly<CounselingNotesProps>): JSX.Element {
    const careComponentNotesId = `careComponentNotes-${id}`;

    return (
        <Notes
            id={careComponentNotesId}
            dataCy={dataCy}
            label={label}
            value={value}
            isEditable={isEditable}
            onTextChange={onTextChange}
            containerClass={styles.notesContainer}
        />
    );
}

export default CareComponentNotes;
